import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

// Pages Components
import WelcomeComp from "./WelcomeComp"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import Summary from "./Summary"
import { useRole } from "hooks/useRole"
import GenderChart from "./GenderChart"
import WardMap from "./WardMap"
import BirminghamMap from "./BirminghamMap"
import AttendeesByAge from "./AttendeesByAge"
import SimCardsDistributed from "./SimCardsDistributed"
import AttendanceOverTime from "./AttendanceOverTime"

const Dashboard = props => {
  const dispatch = useDispatch()
  const { isAdmin, isVendor } = useRole()

  //////////////////BASIC SETTING STATE/////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //////////////////////////////////////

  useEffect(() => {
    dispatch(onGetChartsData())
  }, [dispatch])

  //meta title
  document.title =
    "Dashboard | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Home")}
            breadcrumbItem={props.t("Dashboard")}
          />

          {/* Welcome Section */}
          <Row className="mb-4">
            <Col>
              <WelcomeComp />
            </Col>
          </Row>

          {/* Summary Section */}
          {isAdmin && (
            <Row className="mb-4">
              <Col>
                <Summary />
              </Col>
            </Row>
          )}

          {/* Ward & Gender Charts */}
          {isAdmin && (
            <Row className="mb-4">
              {/* <Col xl="4" className="mb-3 d-none">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">London Ward Map</h5>
                    <WardMap />
                  </CardBody>
                </Card>
              </Col> */}
              <Col xl="8" className="mb-3">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">Birmingham Ward Map</h5>
                    <BirminghamMap />
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4" className="mb-3">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">Gender Distribution</h5>
                    <GenderChart />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          {/* Other Charts */}
          {isAdmin && (
            <Row className="mb-4">
              <Col xl="4" className="mb-3">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">Attendees by Age</h5>
                    <AttendeesByAge />
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4" className="mb-3">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">SIM Cards Distributed</h5>
                    <SimCardsDistributed />
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4" className="mb-3">
                <Card className="shadow-sm h-100">
                  <CardBody>
                    <h5 className="card-title mb-3">Attendance Over Time</h5>
                    <AttendanceOverTime />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
